import React from 'react';
import { CTAButton } from './CTAButton';
import { DECO_STACK, FLAVORS, PRICE } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';

/**
 * COMPRA. La última impresión visual vuelve al deseo inicial: cookies + los
 * dos tomos + el precio + el CTA.
 */
export function FinalCta() {
  const closingFlavors = FLAVORS.slice(1, 4);
  return <section className="overflow-hidden bg-ivory py-14 sm:py-24" aria-labelledby="final-title" data-id="element-90" data-mp="15fgjgp4adb31">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-91" data-mp="1jb230grr32o2">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-92" data-mp="1ed0n24pmfjgt">
          <div className="relative order-2 flex items-center justify-center lg:order-1" data-id="element-93" data-mp="1t3g4r9itw9a8">
            <div className="absolute left-1/2 top-1/2 h-[78%] w-[86%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold-pale/70 blur-2xl" aria-hidden data-id="element-94" data-mp="1o43nd4aq7uf1" />
            <div className="mockup-ground absolute bottom-2 left-1/2 h-9 w-[70%] -translate-x-1/2 blur-md" aria-hidden data-id="element-95" data-mp="1x4tf9wwv90nh" />
            <img src={HERO_IMAGE_URL} alt="Los dos tomos de 100 New York Cookies junto a cookies rellenas." loading="lazy" decoding="async" className="animate-breathe relative max-h-[300px] w-full object-contain drop-shadow-[0_24px_40px_rgba(53,47,50,0.2)] sm:max-h-[400px]" data-id="element-96" data-mp="n7fdpjpo0sax" />
            <img src={DECO_STACK} alt="" aria-hidden loading="lazy" style={{
            ['--drift-rot' as string]: '6deg'
          }} className="animate-drift absolute -bottom-2 -right-2 h-24 w-24 rounded-full object-cover shadow-bakery sm:h-32 sm:w-32" data-id="element-97" data-mp="1658heo84569d" />
          </div>

          <div className="order-1 text-center lg:order-2 lg:text-left" data-id="element-98" data-mp="1kvfoy8wl14va">
            <p className="inline-flex items-center gap-2 rounded-full bg-gold-pale px-3 py-1.5 font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-gold-deep sm:text-[0.64rem]" data-id="element-99" data-mp="1ptr3gwxto3ju">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden data-id="element-100" data-mp="3qvguc9sd0zh9" />
              Último paso
            </p>
            <h2 id="final-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.6rem]" data-id="element-101" data-mp="3lxf9bjbdiq35">
              Empezá con la primera receta hoy.
              <span className="mt-2 block text-gold-deep" data-id="element-102" data-mp="3uufulh35c82d">Las otras 99 ya están esperando.</span>
            </h2>

            <div className="mt-8 inline-flex flex-col items-center gap-3 rounded-5xl bg-cream px-7 py-6 shadow-bakery-sm lg:items-start" data-id="element-103" data-mp="8goc6wboksmp">
              <div className="flex items-center gap-2.5" data-id="element-104" data-mp="mffnyc32m27o">
                <span className="font-sans text-[0.68rem] font-bold uppercase tracking-[0.1em] text-charcoal/70" data-id="element-105" data-mp="ievp942umqjf">
                  100 recetas
                </span>
                <span className="text-caramel" aria-hidden data-id="element-106" data-mp="2o83t4qz9yzq3">
                  +
                </span>
                <span className="font-sans text-[0.68rem] font-bold uppercase tracking-[0.1em] text-charcoal/70" data-id="element-107" data-mp="2k81tend3ogdg">
                  2 tomos digitales
                </span>
              </div>
              <p className="font-display font-display-black text-[2.6rem] leading-none tabular-nums text-charcoal sm:text-[3.2rem]" data-id="element-108" data-mp="2e33vqi024w8s">
                <span className="align-top font-display text-base font-bold text-gold-deep sm:text-lg" data-id="element-109" data-mp="25blgqaeukmha">
                  {PRICE.currency}{' '}
                </span>
                {PRICE.current}
              </p>
              <p className="font-sans text-[0.72rem] font-semibold uppercase tracking-[0.14em] text-charcoal/55" data-id="element-110" data-mp="1vdxbgqjm7wkv">
                {PRICE.note}
              </p>
            </div>

            <div className="mt-8" data-id="element-111" data-mp="1mcpq19276q87">
              <CTAButton label="Quiero hacer estas cookies" size="lg" className="w-full lg:w-auto" data-id="element-112" data-mp="1mdqzxa7h96oc" />
              <p className="mt-4 font-sans text-[0.74rem] leading-relaxed text-charcoal/50" data-id="element-113" data-mp="3bsp3h2cun1tn">
                {PRICE.fx}
              </p>
            </div>
          </div>
        </div>

        {/* Cierre: el producto, no el texto. */}
        <ul className="mt-12 grid grid-cols-3 gap-3 sm:gap-5" data-id="element-114" data-mp="1gnpnz8s5u15e">
          {closingFlavors.map(flavor => <li key={flavor.id} data-id="element-115" data-mp="1bnbkm41i7fdp">
              <img src={flavor.image} alt={flavor.alt} loading="lazy" decoding="async" className="aspect-square w-full rounded-4xl object-cover shadow-bakery-sm" data-id="element-116" data-mp="16ps2gt1oqigh" />
            </li>)}
        </ul>
      </div>
    </section>;
}